// Function to handle opening details and scrolling to the target
function openDetailsAndScroll(hash) {
  if (hash) {
    document.querySelectorAll('.collapsible-menu li').forEach(li => {
      li.classList.remove('link-open');
    });

    document.querySelectorAll('a.anchor-title-link[href^="#"]').forEach(li => {
      li.classList.remove('link-open');
    });
    
    const anchor = document.querySelector(`a.anchor-title-link[href="${ hash }"]`);
    if (anchor) {
      anchor.closest('ul').previousElementSibling?.classList.add('link-open');
      anchor.classList.add('link-open');
    }
    
    const target = document.querySelector(hash); // Get the target element
    if (target) {
      const parentDetails = target.closest('details'); // Find the closest <details> parent
      if (parentDetails) {
        parentDetails.open = true; // Open the <details> tag
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'instant', block: 'center' });
        }, 100); // Slight delay ensures smooth scroll after details open
      }
    }
  }
}

// Handle initial page load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    openDetailsAndScroll(window.location.hash);
  }, "500");
});

// Handle anchor clicks
document.querySelectorAll('a.anchor-title-link[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const hash = anchor.getAttribute('href');
    openDetailsAndScroll(hash);
  });
});

// --- Intersection Observer for Active Link Tracking ---
const observerOptions = {
  root: null, // Viewport as root
  rootMargin: '0px',
  threshold: 0.5 // Trigger when 50% of the element is visible
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    setTimeout(() => {
      if (entry.isIntersecting && (entry.target.getBoundingClientRect().top > 0 && entry.target.getBoundingClientRect().top < window.innerHeight)) {
        const id = entry.target.id;
        if (id) {
          // Clear previous highlights
          document.querySelectorAll('.collapsible-menu li').forEach(li => {
            li.classList.remove('link-open');
          });
  
          document.querySelectorAll('a.anchor-title-link[href^="#"]').forEach(anchor => {
            anchor.classList.remove('link-open');
          });
  
          // Highlight the current anchor
          const activeAnchor = document.querySelector(`a.anchor-title-link[href="#${id}"]`);
          if (activeAnchor) {
            activeAnchor.closest('ul').previousElementSibling?.classList.add('link-open');
            activeAnchor.classList.add('link-open');
          }
  
          // Handle siblings if side-by-side
          if (entry.target.classList.value.includes('column-heading')) {
            const siblings = entry.target.closest('.grid').querySelectorAll('.column-heading');
            siblings.forEach(sibling => {
              if (sibling !== entry.target && sibling.getBoundingClientRect().top < window.innerHeight) {
                const siblingId = sibling.id;
                const siblingAnchor = document.querySelector(`a.anchor-title-link[href="#${siblingId}"]`);
                siblingAnchor?.classList.add('link-open');
              } 
              if (sibling !== entry.target && sibling.getBoundingClientRect().top < 0 || sibling !== entry.target && sibling.getBoundingClientRect().top > window.innerHeight) {
                const siblingId = sibling.id;
                const siblingAnchor = document.querySelector(`a.anchor-title-link[href="#${siblingId}"]`);
                siblingAnchor?.classList.remove('link-open');
              }
            });
          }
        }
      }
    }, "500");
  });
}, observerOptions);

// Observe all sections with IDs
document.querySelectorAll('.anchor-heading, .column-heading').forEach(section => {
  observer.observe(section);
});
